import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { ChannelGroup } from 'ops/common/models/channel-group';
import { Observable } from 'rxjs';
@Injectable({ providedIn: 'root' })
export class ChannelGroupApiService {
    private domain: string;
    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }
    getGroups(): Observable<ChannelGroup[]> {
        return this.http.get<ChannelGroup[]>(`${this.domain}/api/channel-groups`);
    }
}
